module.exports = __webpack_public_path__ + "img/jnmh_03.01c3f39f.jpg";